export enum TIME_CLAIM {
  HALF_DAY = 0,
  FULL_DAY = 1,
}
